var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnTap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.359.618h2.518c.647-.824 1.798-.824 2.373 0h2.519c1.294 0 1.294 2.023 0 2.023h-2.447a.57.57 0 01-.288.3V6.09c.863 0 1.583.45 1.583 1.35v2.846c7.624-.15 6.329 8.093 6.257 10.715h-4.676v-3.597c0-1.424-.575-1.948-1.653-1.873H2.447v1.5H0V8.71h2.447v1.574h9.134V7.438c0-.9.647-1.349 1.51-1.349V2.942a.567.567 0 01-.288-.3h-2.446c-1.295 0-1.295-2.024 0-2.024h.002z",
    fill: "#01A847",
    fillRule: "evenodd"
  })));
}

export default SvgIcnTap;